// Shared icon lookup for Landing pages that resolve an icon component from a
// string key stored in data (e.g. MARKETING_PAGE_DEFS' `icon: 'FiCheckSquare'`).
//
// This replaces `import * as FiIcons from 'react-icons/fi'` + `FiIcons[key]`
// dynamic bracket access, which defeats webpack tree-shaking entirely -
// dynamic property access on a namespace import means webpack can't prove
// which exports are unused, so it keeps the whole react-icons/fi module
// (every Fi* icon) in the bundle. Importing only the icons actually
// referenced by data/marketingPages.js keeps the bundle to just those icons.
import {
    FiAtSign,
    FiArchive,
    FiArrowRight,
    FiArrowUpRight,
    FiBell,
    FiBookmark,
    FiBook,
    FiBookOpen,
    FiBriefcase,
    FiCamera,
    FiCalendar,
    FiCheckCircle,
    FiCheckSquare,
    FiClipboard,
    FiClock,
    FiCloud,
    FiCode,
    FiCopy,
    FiDroplet,
    FiEdit3,
    FiFile,
    FiFileText,
    FiFilter,
    FiFilm,
    FiFolder,
    FiGift,
    FiGlobe,
    FiGrid,
    FiHash,
    FiHeart,
    FiHome,
    FiImage,
    FiInbox,
    FiLayers,
    FiLink,
    FiLink2,
    FiLock,
    FiMapPin,
    FiMaximize,
    FiMessageCircle,
    FiMessageSquare,
    FiMic,
    FiMonitor,
    FiPaperclip,
    FiPlayCircle,
    FiRefreshCw,
    FiRepeat,
    FiRotateCcw,
    FiScissors,
    FiSearch,
    FiSend,
    FiSettings,
    FiShield,
    FiShoppingBag,
    FiSmartphone,
    FiStar,
    FiTool,
    FiTrendingUp,
    FiType,
    FiUser,
    FiUsers,
    FiXCircle,
    FiZap
} from 'react-icons/fi';
// Despite the filename, this map also carries a handful of brand logos
// (react-icons/si "Simple Icons") for platforms referenced in marketing
// data, e.g. the /guides/save-from-* pages. Same lookup-by-string-key
// pattern as the Fi* glyphs above.
import { SiInstagram, SiTiktok, SiX, SiWhatsapp } from 'react-icons/si';

const FI_ICON_MAP = {
    FiAtSign,
    FiArchive,
    FiArrowRight,
    FiArrowUpRight,
    FiBell,
    FiBookmark,
    FiBook,
    FiBookOpen,
    FiBriefcase,
    FiCamera,
    FiCalendar,
    FiCheckCircle,
    FiCheckSquare,
    FiClipboard,
    FiClock,
    FiCloud,
    FiCode,
    FiCopy,
    FiDroplet,
    FiEdit3,
    FiFile,
    FiFileText,
    FiFilter,
    FiFilm,
    FiFolder,
    FiGift,
    FiGlobe,
    FiGrid,
    FiHash,
    FiHeart,
    FiHome,
    FiImage,
    FiInbox,
    FiLayers,
    FiLink,
    FiLink2,
    FiLock,
    FiMapPin,
    FiMaximize,
    FiMessageCircle,
    FiMessageSquare,
    FiMic,
    FiMonitor,
    FiPaperclip,
    FiPlayCircle,
    FiRefreshCw,
    FiRepeat,
    FiRotateCcw,
    FiScissors,
    FiSearch,
    FiSend,
    FiSettings,
    FiShield,
    FiShoppingBag,
    FiSmartphone,
    FiStar,
    FiTool,
    FiTrendingUp,
    FiType,
    FiUser,
    FiUsers,
    FiXCircle,
    FiZap,
    SiInstagram,
    SiTiktok,
    SiX,
    SiWhatsapp
};

export default FI_ICON_MAP;
